export const API_URL = `/api/v1`;

export const axiosConfig = {
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    },
}
